import { render, staticRenderFns } from "./PostModal.vue?vue&type=template&id=05193392&scoped=true"
import script from "./PostModal.vue?vue&type=script&lang=js"
export * from "./PostModal.vue?vue&type=script&lang=js"
import style0 from "./PostModal.vue?vue&type=style&index=0&id=05193392&lang=less&scoped=true"
import style1 from "./PostModal.vue?vue&type=style&index=1&id=05193392&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05193392",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05193392')) {
      api.createRecord('05193392', component.options)
    } else {
      api.reload('05193392', component.options)
    }
    module.hot.accept("./PostModal.vue?vue&type=template&id=05193392&scoped=true", function () {
      api.rerender('05193392', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sales/salesReps/component/PostModal.vue"
export default component.exports